import { createFileRoute, redirect } from '@tanstack/react-router';

import { tpaSections } from '@/features/tpas';

/*
 * Bare `/tpas/:id` redirects to the first section (profile), matching the
 * prototype's default-section behavior. The sectioned view lives in
 * `$tpaId/$section`.
 */
export const Route = createFileRoute('/_auth/tpas/$tpaId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/tpas/$tpaId/$section',
      params: {
        tpaId: params.tpaId,
        section: tpaSections[0]!.id,
      },
      replace: true,
    });
  },
});
